export default "__VITE_ASSET__DV9CDndE__"